var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconButtonAdd32Filled = function SvgIconButtonAdd32Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.752 6.2A3.533 3.533 0 0 0 6.22 9.734v12.533A3.533 3.533 0 0 0 9.752 25.8h12.533a3.533 3.533 0 0 0 3.534-3.533V9.734A3.533 3.533 0 0 0 22.285 6.2H9.752Zm5.138 10.933V22h2.267v-4.867h4.866v-2.266h-4.866V10H14.89v4.867h-4.867v2.266h4.867Z",
    fill: "current"
  })));
};
export default SvgIconButtonAdd32Filled;